import React, { Component } from 'react'
import checkLogin from '../../Utils/checkLogin'
import LoaderSpinner from '../../../componentes/LoaderSpinner'
import { Button, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import palette from '../../../theme/palette'
import DateRangePickers from '../Dashboard/components/DateRangePickers'
import moment from 'moment'
import { LineChart } from './components/LineChart'
import request from 'superagent'
import authHeader from '../../Utils/AuthHeader'
import { defaultPaperPadding, tableRowBackground, url_endpoint } from '../../../config'
import { ExportToCsv } from 'export-to-csv'
import { ArrowDropDown } from '@material-ui/icons'

class CampaignsDashboard extends Component {
    constructor(props) {
        super(props)

        this.props.setTitulo('Dashboard Publicitária')

        const today = new Date()
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

        this.state = {
            client: null,
            loading: true,
            genericDialogOpen: false,
            genericDialogTitle: '',
            genericDialogMessage: '',
            genericDialogAdditionalCallback: async () => { },
            startRange: moment(firstOfMonth),
            endRange: moment(),
            campaignsData: [],
            campaignOrderField: null,
            adsData: [],
            adsOrderField: null,
            playChartData: [],
            clicksChartData: [],
        }
    }

    async componentDidMount() {
        const clientData = await checkLogin(false)

        await this.getData()

        this.setState({ loading: false, client: clientData })
    }

    getDiaryIdentifier(date) {
        const day = date.getDate()
        const dayString = day < 10 ? `0${day}` : day
        const month = date.getMonth()
        const monthString = month < 10 ? `0${month}` : month
        const year = date.getFullYear()

        return `${year}${monthString}${dayString}`
    }

    getLabelFromDate(date) {
        const day = date.getDate()
        const dayString = day < 10 ? `0${day}` : day
        const month = date.getMonth() + 1
        const monthString = month < 10 ? `0${month}` : month
        const year = date.getFullYear()

        return `${dayString}/${monthString}/${year}`
    }

    async getData() {
        try {
            const resData = await request.get(`${url_endpoint}adCampaign/dataForDash/${this.state.startRange.toISOString()}/${this.state.endRange.toISOString()}`).set(authHeader())

            const campaignsData = resData.body

            const diffInDays = (this.state.endRange.diff(this.state.startRange, 'days') + 1)

            const startDate = this.state.startRange.toDate()

            let playChartData = []
            let clicksChartData = []

            const adsData = []

            campaignsData.forEach((c) => {
                adsData.push(...c.CampaignAudios)
            })

            for (let i = 0; i < diffInDays; i++) {
                const tempDate = new Date(startDate)
                const actualDate = new Date(tempDate.setDate(tempDate.getDate() + i))

                const actualDateIdentifier = this.getDiaryIdentifier(actualDate)
                const actualDateLabel = this.getLabelFromDate(actualDate)

                for (let j = 0; j < campaignsData.length; j++) {
                    const campaign = campaignsData[j]
                    const campaignMetrics = campaign.metrics ?? {}

                    if (campaignMetrics.total == undefined) {
                        campaignMetrics.total = {
                            clickLink: 0,
                            play: 0,
                        }
                    }

                    if (campaignMetrics[actualDateIdentifier] == undefined) {
                        campaignMetrics[actualDateIdentifier] = {
                            clickLink: 0,
                            play: 0,
                        }
                    }

                    const actualPlayChartDataIndex = playChartData.findIndex((d) => d.label == actualDateIdentifier)

                    if (actualPlayChartDataIndex != -1) {
                        playChartData[actualPlayChartDataIndex].value = playChartData[actualPlayChartDataIndex].value + (campaignMetrics[actualDateIdentifier].play ?? 0)
                    } else {
                        playChartData.push({
                            label: actualDateLabel,
                            value: campaignMetrics[actualDateIdentifier].play ?? 0
                        })
                    }

                    const actualClicksChartDataIndex = clicksChartData.findIndex((d) => d.label == actualDateIdentifier)

                    if (actualClicksChartDataIndex != -1) {
                        clicksChartData[actualClicksChartDataIndex].value = clicksChartData[actualClicksChartDataIndex].value + (campaignMetrics[actualDateIdentifier].clickLink ?? 0)
                    } else {
                        clicksChartData.push({
                            label: actualDateLabel,
                            value: campaignMetrics[actualDateIdentifier].clickLink ?? 0
                        })
                    }

                    campaignMetrics.total.play = campaignMetrics.total.play + (campaignMetrics[actualDateIdentifier].play == undefined ? 0 : campaignMetrics[actualDateIdentifier].play)
                    campaignMetrics.total.clickLink = campaignMetrics.total.clickLink + (campaignMetrics[actualDateIdentifier].clickLink == undefined ? 0 : campaignMetrics[actualDateIdentifier].clickLink)

                    campaign.metrics = campaignMetrics
                }
            }

            this.setState({ campaignsData: campaignsData, adsData: adsData, playChartData: playChartData, clicksChartData: clicksChartData })
        } catch (e) {
            this.setState({ loading: false })
            this.openDialog('Erro ao buscar dados', e.response.text)
        }
    }

    /**
     * Function to render a data card, just receive the formated values and return the element
     * @param {String} title 
     * @param {Array<object>} dataObjects Format = {label: String, value: number}
     * @returns card element
     */
    buildDataCard(title, dataObjects) {
        let valuesElements = []

        for (let i = 0; i < dataObjects.length; i++) {
            const data = dataObjects.at(i)

            valuesElements.push(
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', marginBottom: '15px', color: palette.primary.main, fontWeight: 'bold' }}>{data.label}</h1>
                    <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{data.value}</span>
                </div>
            )
        }

        return <Paper style={{ margin: '20px 0', display: 'flex', gap: '10px', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center', width: '100%', padding: '10px' }}>
            <div style={{ width: '650px', minWidth: '0', padding: '0 5px' }}>
                <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '22px', color: palette.primary.main, fontWeight: 'bold' }}>{title}</h1>
            </div>
            <div style={{ padding: '0 5px', display: 'contents', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                {valuesElements}
            </div>
        </Paper>
    }

    openDialog(title, message, additionalCallback) {
        this.setState({ genericDialogOpen: true, genericDialogTitle: title, genericDialogMessage: message, genericDialogAdditionalCallback: additionalCallback })
    }

    changerangedata = async (startDate, endDate) => {
        this.setState({ loading: true })

        const startRange = moment(startDate).startOf('day').toDate()
        const endSelected = moment(endDate).startOf('day').toDate()

        endSelected.setHours(23, 59, 59)

        this.setState({ startRange: moment(startRange), endRange: moment(endSelected) })

        await this.getData()

        this.setState({ loading: false })
    }

    generateDataRows(items, orderBy) {
        if (items.length == 0) {
            return []
        }

        let rows = []

        for (let i = 0; i < items.length; i++) {
            const actualItem = items[i]
            let metrics = actualItem.metrics
            if (metrics == undefined) {
                metrics = {
                    total: {
                        play: 0,
                        clickLink: 0,
                    }
                }
            }
            if (metrics.total == undefined) {
                metrics.total = {
                    play: metrics.play ?? 0,
                    clickLink: metrics.clickLink ?? 0,
                }
            }
            actualItem.metrics = metrics

        }

        if (orderBy != null) {
            if (orderBy == 'clickLink' || orderBy == 'play') {
                items.sort((a, b) => b.metrics.total[orderBy] - a.metrics.total[orderBy])
            } else if (orderBy == 'createdAt') {
                items.sort((a, b) => Date.parse(b[orderBy]) - Date.parse(a[orderBy]))
            } else {
                items.sort((a, b) => a[orderBy].localeCompare(b[orderBy].toLowerCase()))
            }
        }

        for (let i = 0; i < items.length; i++) {
            const actualItem = items[i]

            rows.push(
                <TableRow style={{ backgroundColor: i % 2 == 0 ? tableRowBackground : 'transparent' }}>
                    <TableCell align="left" style={{ color: palette.primary.main, fontWeight: 'bold', fontSize: '17px', }}>{actualItem.title}</TableCell>
                    <TableCell align="left" style={{ color: 'grey', fontSize: '17px', }}>{moment(actualItem.createdAt).format('DD/MM/YYYY')}</TableCell>
                    <TableCell align="left" style={{ color: 'grey', fontSize: '17px', }}>{actualItem.metrics.total.play ?? 0}</TableCell>
                    <TableCell align="left" style={{ color: 'grey', fontSize: '17px', }}>{actualItem.metrics.total.clickLink ?? 0}</TableCell>
                </TableRow>
            )
        }

        return rows
    }

    async exportCSV() {
        this.setState({ loading: true })
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            title: `Exportação de dados de campanhas (Período de ${this.state.startRange.format('DD/MM/YYYY')} à ${this.state.endRange.format('DD/MM/YYYY')})`,
            showTitle: true,
            filename: `Exportação Blogplay ${moment().format('DD/MM/YYYY HH:mm')}`
        };

        let data = []

        data.push(['Dados Gerais', ''])
        data.push(['Total de Reproduções', this.state.playChartData.reduce((total, actualData) => total + actualData.value, 0).toString()])
        data.push(['Total de Cliques', this.state.clicksChartData.reduce((total, actualData) => total + actualData.value, 0).toString()])

        data.push(['', ''])

        data.push(['Dados de Campanhas', ''])
        data.push(['', ''])

        this.state.campaignsData.forEach((campaignData) => {
            data.push([`Campanha: ${campaignData.title}`, ''])
            data.push(['Total de Reproduções', campaignData.metrics.total.play.toString()])
            data.push(['Total de Cliques', campaignData.metrics.total.clickLink.toString()])
            data.push(['', ''])
        })

        data.push(['Dados de Anúncios', ''])

        this.state.adsData.forEach((adData) => {
            data.push([`Anúncio: ${adData.title}`, ''])
            data.push(['Total de Reproduções', adData.metrics.total.play.toString()])
            data.push(['Total de Cliques', adData.metrics.total.clickLink.toString()])
            data.push(['', ''])

        })

        const csvExporter = new ExportToCsv(options);
        await csvExporter.generateCsv(data);
        this.setState({ loading: false })
    }

    render() {
        return <>
            {this.state.loading && <LoaderSpinner></LoaderSpinner>}
            <Dialog
                open={this.state.genericDialogOpen}
                onClose={async () => {
                    if (this.state.genericDialogAdditionalCallback != null) {
                        await this.state.genericDialogAdditionalCallback()
                    }
                    this.setState({ genericDialogOpen: false })
                }}
            >
                <DialogTitle>
                    <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.genericDialogTitle}</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontSize: '14px' }}>{this.state.genericDialogMessage}</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <span onClick={async () => {
                        if (this.state.genericDialogAdditionalCallback != null) {
                            await this.state.genericDialogAdditionalCallback()
                        }
                        this.setState({ genericDialogOpen: false })
                    }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                        {"OK"}
                    </span>
                </DialogActions>
            </Dialog>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', color: '#f2a404' }}>
                    <span style={{ fontSize: '16px' }}>Filtrar período:</span>
                    <CardHeader action={<DateRangePickers changerangedata={this.changerangedata}></DateRangePickers>} />
                </div>
                <Button variant='contained' color='primary' onClick={() => this.exportCSV()}>Exportar Relatório</Button>
            </div>
            <Grid container spacing={3}>
                <Grid style={{ height: 500 }} item xs={12} sm={12} md={12} lg={7} xl={7}>
                    <LineChart
                        dataObjects={this.state.playChartData} label="Total Reproduções" description="Número de vezes que seu conteúdo foi reproduzido"></LineChart>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                    <LineChart dataObjects={this.state.clicksChartData} label="Total Cliques" description="Número de vezes que seu conteúdo foi clicado"></LineChart>
                </Grid>
            </Grid>
            <Paper style={{ marginTop: '15px', padding: defaultPaperPadding, color: 'grey' }}>
                <h3 style={{ margin: '15px 0' }}>Campanhas</h3>
                <TableContainer>
                    <Table>
                        <TableHead style={{ backgroundColor: 'transparent' }}>
                            <TableRow>
                                <TableCell onClick={() => this.setState({ campaignOrderField: 'title' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Nome da Campanha
                                        <ArrowDropDown style={{ visibility: this.state.campaignOrderField == 'title' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ campaignOrderField: 'createdAt' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Data
                                        <ArrowDropDown style={{ visibility: this.state.campaignOrderField == 'createdAt' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ campaignOrderField: 'play' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        N° de Reproduções
                                        <ArrowDropDown style={{ visibility: this.state.campaignOrderField == 'play' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ campaignOrderField: 'clickLink' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Cliques
                                        <ArrowDropDown style={{ visibility: this.state.campaignOrderField == 'clickLink' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.generateDataRows(this.state.campaignsData, this.state.campaignOrderField)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <Paper style={{ marginTop: '15px', padding: defaultPaperPadding, color: 'grey' }}>
                <h3 style={{ margin: '15px 0' }}>Anúncios</h3>
                <TableContainer>
                    <Table>
                        <TableHead style={{ backgroundColor: 'transparent' }}>
                            <TableRow>
                                <TableCell onClick={() => this.setState({ adsOrderField: 'title' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Anúncio
                                        <ArrowDropDown style={{ visibility: this.state.adsOrderField == 'title' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ adsOrderField: 'createdAt' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Data
                                        <ArrowDropDown style={{ visibility: this.state.adsOrderField == 'createdAt' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ adsOrderField: 'play' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        N° de Reproduções
                                        <ArrowDropDown style={{ visibility: this.state.adsOrderField == 'play' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                                <TableCell onClick={() => this.setState({ adsOrderField: 'clickLink' })} style={{ color: 'grey', cursor: 'pointer' }} align='left'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        Cliques
                                        <ArrowDropDown style={{ visibility: this.state.adsOrderField == 'clickLink' ? 'visible' : 'hidden' }} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.generateDataRows(this.state.adsData, this.state.adsOrderField)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    }
}

export default CampaignsDashboard